$(function () {
  let case_popup_left_container_container
  let _lastFocusedEl = null
  let _trapHandler = null
  let _focusGuard = null
  let _srLoopHandler = null
  let _scrollY = 0
  let _bodyStyleCache = null

  function lockPageScroll() {
    const body = document.body
    if (!body || _bodyStyleCache) return

    _scrollY = window.pageYOffset || window.scrollY || 0
    _bodyStyleCache = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      htmlOverflow: document.documentElement.style.overflow,
    }

    body.style.position = 'fixed'
    body.style.top = `-${_scrollY}px`
    body.style.left = '0'
    body.style.right = '0'
    body.style.width = '100%'
    body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'
  }

  function unlockPageScroll() {
    const body = document.body
    if (!body || !_bodyStyleCache) return

    body.style.position = _bodyStyleCache.position
    body.style.top = _bodyStyleCache.top
    body.style.left = _bodyStyleCache.left
    body.style.right = _bodyStyleCache.right
    body.style.width = _bodyStyleCache.width
    body.style.overflow = _bodyStyleCache.overflow
    document.documentElement.style.overflow = _bodyStyleCache.htmlOverflow

    const restoreY = _scrollY
    _bodyStyleCache = null
    _scrollY = 0
    window.scrollTo(0, restoreY)
  }

  function toggleAriaHidden(node, hidden) {
    if (!node) return

    if (hidden) {
      if (!node.hasAttribute('aria-hidden')) {
        node.setAttribute('data-showcase-aria-hidden', 'true')
      }
      node.setAttribute('aria-hidden', 'true')
      return
    }

    if (node.getAttribute('data-showcase-aria-hidden') === 'true') {
      node.removeAttribute('aria-hidden')
      node.removeAttribute('data-showcase-aria-hidden')
    }
  }

  function toggleShowcaseBackdropAccessibility(hidden) {
    const popup = document.querySelector('.case-popup-content')

    if (!popup) return

    let currentNode = popup

    while (currentNode && currentNode !== document.body) {
      const parentNode = currentNode.parentElement
      if (!parentNode) break

      Array.prototype.forEach.call(parentNode.children, function (sibling) {
        if (sibling === currentNode) return
        toggleAriaHidden(sibling, hidden)
        sibling.inert = hidden
      })

      currentNode = parentNode
    }
  }

  // 焦点陷阱边界：.case-popup-content-container-parent（真正的弹窗容器）
  function getFocusableElements() {
    const container = document.querySelector(
      '.case-popup-content-container-parent'
    )
    if (!container) return []
    return Array.from(
      container.querySelectorAll(
        'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"]), [role="button"]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      // 排除占位锚点
      if (el.classList.contains('last-focusable-element')) return false

      // 检查元素自身及所有祖先，只要有一个 display:none 或 visibility:hidden 就排除
      // 这样能正确处理 swiper fade 隐藏的 slide，以及任何其他隐藏容器
      let node = el
      while (node && node !== container) {
        const style = window.getComputedStyle(node)
        if (style.display === 'none' || style.visibility === 'hidden')
          return false
        node = node.parentElement
      }

      return true
    })
  }

  function updateButtonStates(that) {
    let btnParentEle = that[0]
    console.log(btnParentEle)
    const quantityInput = btnParentEle.querySelector('.js-case-qty__num')
    const increaseBtn = btnParentEle.querySelector('.js-case__adjust--plus')
    const decreaseBtn = btnParentEle.querySelector('.js-case__adjust--minus')
    const current = parseInt(quantityInput.value)

    if (current <= 0) {
      decreaseBtn.setAttribute('aria-disabled', 'true')
    } else {
      decreaseBtn.setAttribute('aria-disabled', 'false')
    }

    increaseBtn.setAttribute('aria-disabled', 'false')
  }
  function changeProductQty(that, flag = false) {
    let val = !flag ? +that.data('qty') : 0,
      cur_val =
        +that
          .parents('.case-item-container')
          .find('.js-case-qty__num')
          .prop('value') + val
    let max = +that
      .parents('.case-item-container')
      .find('.js-case-qty__num')
      .prop('max')
    if (cur_val >= 0 && cur_val <= max) {
      that
        .parents('.case-item-container')
        .find('.js-case-qty__num')
        .prop('value', cur_val)
      that.parents('.case-container-item').find('.tips-content').length > 0 &&
        that.parents('.case-container-item').find('.tips-content').hide()
    } else if (cur_val > max) {
      that
        .parents('.case-item-container')
        .find('.js-case-qty__num')
        .prop('value', max)
      that.parents('.case-container-item').find('.tips-content').length > 0 &&
        that.parents('.case-container-item').find('.tips-content').show()
    }
  }
  function calcProductPrice(total_price) {
    return window.theme.Currency.formatMoney(
      total_price,
      window.theme.strings.moneyFormat
    )
  }
  function update_out_inside_qty(direction = 'outside') {
    let str =
      direction == 'inside' ? '.case-popup-content' : '.header-case-content'
    let str_1 =
      direction == 'inside' ? '.header-case-content' : '.case-popup-content'
    $(`${str} .case-item-container`).each(function () {
      let id = +$(this).find('.js-case-qty__num').data('id'),
        val = $(this).find('.js-case-qty__num').prop('value'),
        index = $(this).data('index')
      $(`${str_1} .case-item`).find(`input[data-id=${id}]`).prop('value', val)
      updateProductPrice(
        $(`${str_1} .case-container-item[data-index="${index}"]`)
      )
    })
  }

  function updateProductPrice(that) {
    let this_val = that.find('.js-case-qty__num')
    val = +this_val.prop('value') > 0 ? this_val.prop('value') : 1
    total_price = val * this_val.data('price')
    flag = that.hasClass('tips-container')
    let compare_at_price = val * this_val.data('compare_at_price')
    that.find('.item-price .on_sale-price').html(calcProductPrice(total_price))
    compare_at_price > 0 &&
      that
        .find('.item-price .compare_at-price')
        .html(calcProductPrice(compare_at_price))
    if (flag) {
      that.find('.item-price').html(calcProductPrice(total_price))
    }
  }
  function update_totalProductPrice() {
    let total_price = +$(
      '[data-product-template-container] .custom_add_to_cart'
    ).data('on_sale_price')
    let total_compare_price = !$(
      '[data-product-template-container] .custom_add_to_cart'
    ).data('compare_at_price')
      ? total_price
      : +$('[data-product-template-container] .custom_add_to_cart').data(
          'compare_at_price'
        )
    $('.header-case-content .case-item .js-case-qty__num').each(function () {
      let temp = +$(this).data('price') * $(this).prop('value')
      total_price += temp
      total_compare_price += !$(this).data('compare_at_price')
        ? temp
        : $(this).data('compare_at_price') * $(this).prop('value')
    })
    let val = calcProductPrice(total_price),
      val_compare = calcProductPrice(total_compare_price)
    let off_price =
      calcProductPrice(total_compare_price - total_price) + ' OFF'
    $('[data-product-template-container] .show-discount').text(off_price)
    $('[data-product-template-container] .product_on-sale-price').text(val)

    if (total_compare_price == total_price) {
      $('[data-product-template-container] .product_compare-at-price').remove()
    } else {
      if (
        $('[data-product-template-container] .price-container').find(
          '.product_compare-at-price'
        ).length > 0
      ) {
        $('[data-product-template-container] .product_compare-at-price').text(
          val_compare
        )
      } else {
        $('[data-product-template-container] .product_on-sale-price').after(
          `<span class='product-single__price--compare-at product_compare-at-price'>${val_compare}</span>`
        )
      }
    }
  }

  async function addOneToCart(variants) {
    for (let i = 0; i < variants.length; i++) {
      let variant = variants[i]
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: variant.id, quantity: variant.quantity }),
      })
      if (!response.ok) {
        throw new Error('添加产品失败: ' + variant.id)
      }
      const data = await response.json()
      await new Promise((resolve) => setTimeout(resolve, 200))
    }
    try {
      const cartRes = await fetch('/cart.js')
      const cart = await cartRes.json()
      if (window.updateStepCartGift) {
        await window.updateStepCartGift(cart)
      }
    } catch (e) {
      console.error('automatische cadeauverwerking mislukt', e)
    }
    $('[data-product-template-container] .custom_add_to_cart').removeClass(
      'loading'
    )
    $('.js-drawer-open-button-right').trigger('click')
  }
  function fadeInPopUp() {
    $('html').addClass('overflow-hidden')
    lockPageScroll()

    // 记录触发元素，关闭后恢复焦点
    _lastFocusedEl = document.activeElement

    let dialog = $('.case-popup-content')
    dialog.removeClass('caseopacity0')
    dialog.removeAttr('aria-hidden')
    dialog.find('.tips-content').hide()

    const srLoopEl = dialog.find('.last-focusable-element')
    srLoopEl
      .attr('tabindex', '0')
      .attr('aria-hidden', 'false')
      .attr('role', 'button')
      .attr('aria-label', window.theme?.strings?.accessibilityClose || 'Sluiten')

    // 屏蔽弹窗外的可访问内容，避免 VoiceOver 扫到背景页面
    toggleShowcaseBackdropAccessibility(true)

    // 延迟聚焦，确保 CSS 过渡完成、元素可交互
    setTimeout(function () {
      const focusable = getFocusableElements()
      if (focusable.length > 0) {
        focusable[0].focus()
      }
    }, 50)

    update_out_inside_qty()

    // 绑定焦点陷阱：无条件拦截 Tab，完全接管，防止浏览器执行默认行为
    if (_trapHandler) {
      document.removeEventListener('keydown', _trapHandler)
    }
    _trapHandler = function (e) {
      if (e.key !== 'Tab') return
      const focusable = getFocusableElements()
      if (focusable.length === 0) return

      // 无条件阻止浏览器默认 Tab 行为
      e.preventDefault()

      const active = document.activeElement
      const currentIndex = focusable.indexOf(active)

      if (e.shiftKey) {
        // Shift+Tab：往前，到头则循环到最后一个
        const prevIndex =
          currentIndex <= 0 ? focusable.length - 1 : currentIndex - 1
        focusable[prevIndex].focus()
      } else {
        // Tab：往后，到尾则循环到第一个
        const nextIndex =
          currentIndex >= focusable.length - 1 ? 0 : currentIndex + 1
        focusable[nextIndex].focus()
      }
    }
    document.addEventListener('keydown', _trapHandler)

    // 兜底：inert 不可靠时，监听全局 focusin，焦点一旦跑出弹窗就强制拉回
    if (_focusGuard) {
      document.removeEventListener('focusin', _focusGuard)
    }
    _focusGuard = function (e) {
      const container = document.querySelector(
        '.case-popup-content-container-parent'
      )
      if (!container) return
      if (!container.contains(e.target)) {
        const focusable = getFocusableElements()
        if (focusable.length > 0) focusable[0].focus()
      }
    }
    document.addEventListener('focusin', _focusGuard)

    if (_srLoopHandler) {
      dialog[0].removeEventListener('focusin', _srLoopHandler)
    }
    _srLoopHandler = function (e) {
      if (!e.target.classList.contains('last-focusable-element')) return

      const closeBtn = dialog[0].querySelector('.first-focusable-element')
      if (closeBtn) {
        setTimeout(function () {
          closeBtn.focus()
        }, 0)
      }
    }
    dialog[0].addEventListener('focusin', _srLoopHandler)
  }

  function fadeOutPopUp(flag = false) {
    $('html').removeClass('overflow-hidden')
    unlockPageScroll()
    $('.product-showcase-info-container .case-popup-content').addClass(
      'caseopacity0'
    )

    $('.product-showcase-info-container .case-popup-content').attr(
      'aria-hidden',
      'true'
    )

    const dialog = document.querySelector('.case-popup-content')
    if (dialog) {
      const srLoopEl = dialog.querySelector('.last-focusable-element')
      if (srLoopEl) {
        srLoopEl.setAttribute('tabindex', '-1')
        srLoopEl.setAttribute('aria-hidden', 'true')
        srLoopEl.removeAttribute('role')
      }

      if (_srLoopHandler) {
        dialog.removeEventListener('focusin', _srLoopHandler)
        _srLoopHandler = null
      }
    }

    // 恢复背景可访问性
    toggleShowcaseBackdropAccessibility(false)

    // 解绑焦点陷阱
    if (_trapHandler) {
      document.removeEventListener('keydown', _trapHandler)
      _trapHandler = null
    }

    // 解绑焦点兜底监听
    if (_focusGuard) {
      document.removeEventListener('focusin', _focusGuard)
      _focusGuard = null
    }

    // 恢复焦点到触发元素
    if (_lastFocusedEl) {
      setTimeout(function () {
        _lastFocusedEl.focus()
        _lastFocusedEl = null
      }, 50)
    }

    if (flag) {
      update_out_inside_qty('inside')
    }
  }
  function setOriginPopUpContent(index) {
    $('.case-popup-right')
      .find(`.right-item[data-index="${index}"]`)
      .addClass('active')
      .attr('aria-selected', 'true')
      .siblings()
      .removeClass('active')
      .attr('aria-selected', 'false')
    case_popup_left_container_container.slideTo(index)
  }

  $('.case-popup-content').click(function () {
    fadeOutPopUp()
  })
  $('.case-popup-content-container').click(function (event) {
    event.stopPropagation()
  })
  $('.product-showcase-info-container .header-case-btn').on(
    'click',
    function () {
      // 点击弹出窗口
      fadeInPopUp()
    }
  )
  $('.product-showcase-info-container .case-hide-btn').on('click', function () {
    // 点击隐藏窗口
    fadeOutPopUp()
  })
  // 点击对应的item进入弹窗
  $('.product-showcase-info-container .header-case-content .case-item').on(
    'click keydown',
    function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return
      }
      let index = $(this).parents('.swiper-slide').data('index')
      setOriginPopUpContent(index)
      fadeInPopUp()
      let val = +$(this).find('.js-case-qty__num').prop('value')
      if (val > 0) {
        $(
          `.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`
        ).addClass('active')
      } else {
        $(
          `.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`
        ).removeClass('active')
      }
    }
  )
  // 点击产品加购根据每个产品的id来循环加购
  $('[data-product-template-container] .custom_add_to_cart').click(function () {
    let product_qty = +$(this)
      .parents('[data-product-form]')
      .find('.product-single__quantity .js-qty__num')
      .prop('value')
    product_qty = product_qty > 1 ? product_qty : 1
    $(this).addClass('loading')
    // 循环每个不同的产品
    let arr_item = [
      {
        id: $(this).data('id'),
        quantity: product_qty,
      },
    ]
    $('.header-case-content .js-case-qty__num').each(function () {
      let qty = +$(this).prop('value')
      if (qty > 0) {
        let obj = {
          id: $(this).data('id'),
          product_id: $(this).data('product-id'),
          quantity: qty,
        }
        arr_item.push(obj)
      }
    })

    arr_item.length > 0 && addOneToCart(arr_item)
  })
  // 点击该处按钮实现+1   点击该处按钮实现-1
  $('.product-showcase-info-container .js-case__adjust').on(
    'click keydown',
    function (event) {
      if (
        event.type === 'keydown' &&
        event.which !== 13 &&
        event.which !== 32
      ) {
        return
      }
      let that = $(this),
        that_parent = $(this).parents('.case-item-container')
      changeProductQty(that)
      updateProductPrice(that_parent)
      updateButtonStates(that_parent)
      if (!!$(this).data('layout')) {
        update_totalProductPrice()
      }
      return false
    }
  )
  $(
    '.product-showcase-info-container .case-popup-content .js-case-qty__num'
  ).on('change', function () {
    let that = $(this),
      that_parent = $(this).parents('.case-item-container')
    updateProductPrice(that_parent)
    changeProductQty(that, true)
  })
  // 弹窗切换item状态
  var case_right_item = $('.case-popup-right .right-item')
  case_right_item.on('click', function () {
    let index = $(this).data('index')
    setOriginPopUpContent(index)
  })
  case_right_item.on('keydown', function (e) {
    if (e.key == 'Enter' || e.key == ' ') {
      e.preventDefault()
      e.stopPropagation()
      $(this).trigger('click')
    }
  })
  // m端点击弹窗关闭
  $('.case-popup-content .m-close ').on('click', function () {
    fadeOutPopUp()
  })
  //点击确定加购
  $('.case-popup-left .confirm-btn ').on('click keydown', function (event) {
    if (event.type === 'keydown' && event.which !== 13 && event.which !== 32) {
      return
    }
    let index = $(this).parents('.left-item').data('index')
    let val = +$(this)
      .parents('.case-item-container')
      .find('.js-case-qty__num')
      .prop('value')
    update_out_inside_qty('inside')
    calcProductPrice()
    update_totalProductPrice()
    if (val > 0) {
      $(
        `.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`
      ).addClass('active')
    } else {
      $(
        `.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`
      ).removeClass('active')
    }
  })

  //循环里面的swiper
  case_popup_left_container_container = new Swiper(
    '.case-popup-left-container>.swiper',
    {
      allowTouchMove: false,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
    }
  )

  $('.case-popup-left .left-item').each(function (index) {
    new Swiper(`.left-swiper-${index} .swiper`, {
      pagination: {
        el: `.left-swiper-${index} .swiper-pagination`,
        clickable: true,
      },
    })
  })
  function swiperFn() {
    if ($(window).width() <= 589) {
      new Swiper('.header-case-content .swiper', {
        autoHeight: true,
        navigation: {
          nextEl: '.header-case-content .swiper-button-next',
          prevEl: '.header-case-content .swiper-button-prev',
        },
        a11y: {
          prevSlideMessage: 'Vorige dia',
          nextSlideMessage: 'Volgende dia',
          firstSlideMessage: 'Dit is de eerste dia',
          lastSlideMessage: 'Dit is de laatste dia',
          paginationBulletMessage: 'Ga naar dia {{index}}',
        },
      })
    }
  }
  swiperFn()
  $(window).resize(function () {
    swiperFn()
  })
})
